import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import util from 'util/Util.js';
import _template from 'properties/table/column-main-time.ejs';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';
import constants from 'Constants';

class MainTimeValueView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.iniConf={
            ampmPrefix: ' ',
            spinnerImage: '',
            spinnerIncDecOnly: true,
            spinnerSize: [15,17,0],
            show24Hours: false,
            showSeconds: false
        };
        
        this.events = {
            'change input[type=radio]' : 'setTimeValue',
            'change #timeValueSpecific' : 'setSpecificTime',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change input[type=checkbox]' : 'updateCheckbox'
        };

        if(this.colId){
            let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }

        if(!this.columnModel.get('borderStyle')) {
            this.columnModel.set('borderStyle','solid',{silent:true});
        }

        if(!this.columnModel.get('borderSize')) {
            this.columnModel.set('borderSize','1',{silent:true});
        }

        if(!this.columnModel.get('cornerRadius')) {
            this.columnModel.set('cornerRadius','0',{silent:true});
        }

        if(this.columnModel.get('borderColor')) {
            this.columnModel.set('borderColor','#CCCCCC',{silent:true});
        }

        if(!this.columnModel.get('specific')) {
            this.columnModel.set('specific','',{silent:true});
        }

        if(!this.columnModel.get('is24HourClock')) {
            this.columnModel.set('is24HourClock','false', {silent: true});
        }
        if(!this.columnModel.get('hasSeconds')) {
            this.columnModel.set('hasSeconds', 'false', {silent: true});
        }

        if (util.isTrue( this.columnModel.get('showEmpty')) ) {
            this.columnModel.set('timeValueType', 'Empty', {silent: true});
        }
        if (util.isTrue( this.columnModel.get('showNow')) ) {
            this.columnModel.set('timeValueType', 'Now', {silent: true});
        }

        if (!util.isTrue( this.columnModel.get('showNow')) && !util.isTrue( this.columnModel.get('showEmpty')) ) {
            this.columnModel.set('timeValueType', 'Specific', {silent: true});
        }
        
        return this;
    }

    get columnModel() {
        return this.model.get('gridData')[this.colId];
    }

    setTimeValue(ev) {
        ev.preventDefault();
        const defaultDateTime = constants.DATE_TIME_DEFAULT_VALUE;
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldPropVal = this.columnModel.get(propName);
        const columnModel = this.columnModel;


        this.columnModel.set( 'showEmpty', 'false', {silent:true} );
        this.columnModel.set( 'showNow', 'false', {silent:true} );
        this.columnModel.set( 'specific', '', {silent:true} );


        if(propVal === 'Empty') {
            this.resetSpecific();
            // PF-4915 - Flash leaves specific set to '1970-01-01 12:00:00'
            // this.columnModel.set('specific','  :  :  ', {silent:true});
            this.columnModel.set('specific', defaultDateTime, {silent:true});
            this.columnModel.set( 'showEmpty', 'true', {silent:true} );
        }
        if(propVal === 'Now') {
            const date = new Date();
            // PF-4915 - Flash leaves specific set to '1970-01-01 12:00:00'. Server renders its own "now" if showNow === true
            // The date / time set by this commented-out statement is in a wrong, vergose format anyway.
            // this.columnModel.set('specific', date, {silent:true});
            this.columnModel.set('specific', defaultDateTime, {silent:true});
            this.columnModel.set( 'showNow', 'true', {silent:true} );

        }
        if(propVal === 'Specific') {
            if (this.columnModel.get('specific') === '') {
                this.columnModel.set('specific', defaultDateTime, {silent:true});
            }

            $('#timeValueSpecific').prop('disabled', false);

        }

        this.columnModel.set(propName, propVal);
        this.render();

        undoService.add({
            undo: () => {    
                columnModel['attributes'].showEmpty = 'false';
                columnModel['attributes'].showNow = 'false';
                columnModel['attributes'].specific = ''


                if(oldPropVal === 'Empty') {
                    this.resetSpecific();
                    columnModel['attributes'].specific = defaultDateTime;
                    columnModel['attributes'].showEmpty = 'true';
                } else if(oldPropVal === 'Now') {
                    const date = new Date();
                    columnModel['attributes'].specific = defaultDateTime;
                    columnModel['attributes'].showNow = 'true';
                } else if(oldPropVal === 'Specific') {
                    if (columnModel.get('specific') === '') {
                        columnModel['attributes'].specific = defaultDateTime;
                    }

                    $('#timeValueSpecific').prop('disabled', false);

                }
                columnModel.set('timeValueType', oldPropVal, {silent: true});
                this.render();
            },
            redo: () => {
                columnModel['attributes'].showEmpty = 'false';
                columnModel['attributes'].showNow = 'false';
                columnModel['attributes'].specific = ''


                if(propVal === 'Empty') {
                    this.resetSpecific();
                    columnModel['attributes'].specific = defaultDateTime;
                    columnModel['attributes'].showEmpty = 'true';
                } else if(propVal === 'Now') {
                    const date = new Date();
                    columnModel['attributes'].specific = defaultDateTime;
                    columnModel['attributes'].showNow = 'true';
                } else if(propVal === 'Specific') {
                    if (columnModel.get('specific') === '') {
                        columnModel['attributes'].specific = defaultDateTime;
                    }

                    $('#timeValueSpecific').prop('disabled', false);

                }

                columnModel.set('timeValueType', propVal, {silent: true});
                this.render();
            }
        }, textConstants.UNDO_MOVE);

    }

    setSpecificTime(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;
        const oldPropVal = '1970-01-01 ' + this.columnModel.get('specific');

        propVal = '1970-01-01 ' + propVal;
        this.columnModel.set('specific', propVal, {silent: true});

        undoService.add({
            undo: () => {
                this.columnModel.set('specific', oldPropVal, {silent: true});
                this.render();
            },
            redo: () => {
                this.columnModel.set('specific', propVal, {silent: true});
                this.render();
            }
        });
    }

    setNow(){
        let is24HourClock = util.isTrue(this.columnModel.get('is24HourClock'));
        let hasSeconds = util.isTrue(this.columnModel.get('hasSeconds'));

        let properties={
            hour12: is24HourClock,
            hour: '2-digit',
            minute:'2-digit'
        };

        if(hasSeconds){
            properties.second='2-digit';
        }

        const time=new Date().toLocaleTimeString([], properties);
        this.columnModel.set('specific', time);
    }

    resetSpecific() {
        $('#timeValueSpecific').prop('disabled', true);
        $('#timeValueSpecific').val('');
    }

    updateCheckbox(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        const oldPropVal = this.columnModel.get(propName);

        this.columnModel.set(propName, propVal, {silent: true});
        this.render();

        undoService.add({
            undo: () => {
                this.columnModel.set(propName, oldPropVal, {silent: true});
                this.render();
            },
            redo: () => {
                this.columnModel.set(propName, propVal, {silent: true});
                this.render();
            }
        });
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.get('gridData')[this.colId].attributes[propName] = propVal;
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if(this.columnModel.get('timeValueType') === 'Specific') {
            $('#timeValueSpecific').timeEntry('enable')
        }else{
            $('#timeValueSpecific').timeEntry('disable')
        }

        $(":radio[value='"+this.columnModel.get('timeValueType')+"']").attr('checked', true);

        let spinner = require('editor/icons/spinner-timeEntry.png');
        let is24HourClock = util.isTrue(this.columnModel.get('is24HourClock'));
        let hasSeconds = util.isTrue(this.columnModel.get('hasSeconds'));

        $(":checkbox[name='is24HourClock']").prop('checked', is24HourClock);
        $(":checkbox[name='hasSeconds']").prop('checked', hasSeconds);



        $('#timeValueSpecific').timeEntry({
            ampmPrefix: ' ',
            spinnerImage: spinner,
            spinnerIncDecOnly: true,
            spinnerSize: [25,24,0],
            show24Hours: is24HourClock,
            showSeconds: hasSeconds,
            defaultTime:util.getTime(this.columnModel.get('specific'), {use24Hour: is24HourClock, useSeconds: hasSeconds})
        });
        $(".timeEntry-control").css({"vertical-align": "-8px", "margin-left":"-23px"});
        if(this.columnModel.get('timeValueType') === 'Empty') {
            $('#timeValueSpecific').val('');
        }


        this.delegateEvents();
        return this;
    }

}

export default MainTimeValueView;
